import { ThemeOptions } from '@mui/material';
import type { ComponentsProps } from '@mui/material/styles';
import type {} from '@mui/x-charts/themeAugmentation';

import { capitalCategoricalPalette } from '../../capitalCategoricalPalette';

// No Theme type parameter: the parameter is unused, and naming it fails the unused-var lint.
// Declaration merging still matches MUI's `interface Components<Theme = unknown>`.
declare module '@mui/material/styles' {
  interface Components {
    MuiPieChart?: {
      defaultProps?: ComponentsProps['MuiPieChart'];
    };
  }
}

export const MuiPieChart: NonNullable<ThemeOptions['components']>['MuiPieChart'] = {
  defaultProps: {
    colors: capitalCategoricalPalette,
    enableKeyboardNavigation: true
  }
};
